<template>
  <div>
    <Head title="Nuevo Proveedor" />

    <!-- Header & Breadcrumbs -->
    <div class="mb-8">
      <div class="flex items-center gap-4 text-sm text-gray-500 mb-4">
        <button class="hover:text-teal-600 transition-colors" title="Volver atrás" @click="back()">
          <i class="fa fa-arrow-left" />
        </button>
        <Link href="/providers" class="hover:text-teal-600 transition-colors">Proveedores</Link>
        <span class="text-gray-300">/</span>
        <span class="text-gray-900 font-medium">Nuevo Proveedor</span>
      </div>

      <h1 class="text-3xl font-bold text-gray-900">Crear Nuevo Proveedor</h1>
    </div>

    <!-- Form -->
    <div class="max-w-4xl">
      <form @submit.prevent="store">
        <div class="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden">
          <div class="p-8">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6">
              <!-- Basic Info Section -->
              <div class="md:col-span-2 pb-2 border-b border-gray-50 mb-2">
                <h2 class="text-lg font-bold text-gray-800 flex items-center gap-2">
                  <i class="fa fa-id-card text-teal-600" />
                  Información de la Empresa
                </h2>
              </div>

              <text-input 
                v-model="form.company_name" 
                :error="form.errors.company_name"
                label="Nombre de la Empresa *"
                placeholder="Ej: Inversiones Globales C.A."
                class="teal-focus"
              />

              <text-input 
                v-model="form.tax_id" 
                :error="form.errors.tax_id"
                label="RIF / Identificación *"
                placeholder="Ej: J-12345678-9"
                class="teal-focus"
              />

              <text-input 
                v-model="form.name" 
                :error="form.errors.name"
                label="Persona de Contacto *"
                placeholder="Nombre completo del contacto..."
                class="teal-focus"
              />

              <text-input 
                v-model="form.email" 
                :error="form.errors.email"
                label="Correo Electrónico"
                type="email"
                placeholder="correo@ejemplo.com"
                class="teal-focus"
              />

              <!-- Contact & Location Section -->
              <div class="md:col-span-2 pb-2 border-b border-gray-50 mt-4 mb-2">
                <h2 class="text-lg font-bold text-gray-800 flex items-center gap-2">
                  <i class="fa fa-map-marker-alt text-teal-600" />
                  Contacto y Ubicación
                </h2>
              </div>

              <text-input 
                v-model="form.phone" 
                :error="form.errors.phone"
                label="Teléfono"
                type="tel"
                placeholder="Número telefónico..."
                class="teal-focus"
              />

              <text-input 
                v-model="form.website" 
                :error="form.errors.website"
                label="Sitio Web"
                type="url"
                placeholder="https://..."
                class="teal-focus"
              />

              <div class="md:col-span-2">
                <text-input 
                  v-model="form.address" 
                  :error="form.errors.address"
                  label="Dirección Fiscal"
                  placeholder="Calle, Edificio, Local..."
                  class="teal-focus"
                />
              </div>

              <text-input 
                v-model="form.city" 
                :error="form.errors.city"
                label="Ciudad"
                placeholder="Ciudad..."
                class="teal-focus"
              />

              <text-input 
                v-model="form.country" 
                :error="form.errors.country"
                label="País"
                placeholder="País..."
                class="teal-focus"
              />

              <!-- Extra Section -->
              <div class="md:col-span-2 pb-2 border-b border-gray-50 mt-4 mb-2">
                <h2 class="text-lg font-bold text-gray-800 flex items-center gap-2">
                  <i class="fa fa-sticky-note text-teal-600" />
                  Notas Adicionales
                </h2>
              </div>

              <div class="md:col-span-2">
                <text-area
                  v-model="form.notes"
                  :error="form.errors.notes"
                  label="Comentarios o Notas"
                  placeholder="Cualquier información relevante sobre el proveedor..."
                  class="teal-focus"
                />
              </div>
            </div>
          </div>

          <div class="px-8 py-5 bg-gray-50 border-t border-gray-100 flex items-center justify-end gap-4">
            <Link href="/providers" class="text-sm font-bold text-gray-400 hover:text-gray-600 transition-colors">
              Cancelar
            </Link>
            <loading-button 
              :loading="form.processing" 
              class="px-8 py-3 bg-teal-600 hover:bg-teal-700 text-white font-black rounded-xl transition-all shadow-lg shadow-teal-100 flex items-center gap-2"
            >
              <i class="fa fa-save" />
              Guardar Proveedor
            </loading-button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextArea from '@/Shared/TextAreaInput'

export default {
  name: 'ProvidersCreate',

  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
    TextArea,
  },

  layout: Layout,

  remember: 'form',

  data() {
    return {
      form: this.$inertia.form({
        name: '',
        company_name: '',
        email: '',
        phone: '',
        address: '',
        city: '',
        country: '',
        tax_id: '',
        website: '',
        notes: '',
      }),
    }
  },

  methods: {
    back() {
      window.history.back()
    },

    store() {
      this.form.post('/providers')
    },
  },
}
</script>

<style scoped>
:deep(.teal-focus input:focus),
:deep(.teal-focus textarea:focus) {
  --tw-ring-color: #0d9488;
  border-color: #0d9488;
}
</style>
